<template>
  <div v-if="analyticsVisible || wclVisible">
    <!-- Layers -->
    <draggable
      v-model="layerButtons"
      ghost-class="ghost"
      @end.prevent="onEnd()"
    >
      <transition-group type="transition" name="flip-list">
        <b-row
          v-for="(element, index) in layerButtons.filter((layer) => layer.display_name != 'POI Uploads')"
          :id="element.name"
          :key="element.name"
          no-gutters
          :class="highlightTopLayer(index)"
          :disabled="
            checkLayerDisable(
              element.name,
              element.zoomControl,
              element.minZoom
            )
          "
          class="layer-container"
          @mouseover="element.poi == true ? (hoveredLayer = element.name) : null"
          @mouseleave="removePanel()"
        >
          <!-- Layer button and respective spinner -->
          <b-col class="col-sm-9 layer-content" @click="toggleLayer(element, $event)">
            <b-button
              :id="element.name"
              class="capitalize cursor vert-align py-2"
              :class="getLayerColClass(index, element)"
              size="sm"
            >
              {{ element.display_name ? element.display_name : element.name }}
            </b-button>
            <b-spinner
              v-if="spinnerManager.includes(element.name)"
              variant="primary"
              small
              class="spinner-custom-position"
            ></b-spinner>
          </b-col>
          <!-- To Top of Layer List and Filter Layer buttons -->
          <b-col class="col-sm-3 center">
            <fa
              @click="
                toTopOfList(
                  element.display_name ? element.display_name : element.name
                )
              "
              title="Move Layer To Top"
              :icon="['fas', 'long-arrow-alt-up']"
              class="img-fluid cursor mx-2 pb-1"
            />
          </b-col>

          <!-- Sliding Panel (Only for poi = true) -->
          <!-- <div v-if="element.poi === true" class="poi-panel-wrapper">
            <div
              class="poi-panel"
              :class="{ 'expanded': hoveredLayer === element.name }"
            >
              <b-button variant="danger" class="remove-btn" @click="removePOI()">REMOVE</b-button>
            </div>
          </div> -->
        </b-row>
      </transition-group>
    </draggable>
  </div>
</template>

<style scoped>
.item:hover {
  background: rgba(65, 65, 65, 0.4);
  cursor: move;
}
.card {
  overflow-y: auto;
  min-height: 350px;
}
.cursor {
  cursor: pointer;
}
.scroll-Container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
.scroll-Container::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
.scroll-Container::-webkit-scrollbar-thumb {
  background-color: #797777;
}
.center {
  text-align: center;
}
.hover:hover {
  color: rgb(30, 197, 132) !important;
  transition: 0.5s;
}
.highlightTopLayer {
  background-color: rgba(216, 216, 216, 0.5);
  border-color: rgba(241, 241, 241, 0.6);
  border-style: solid;
  height: 100%;
  /* box-shadow: inset 0px 0px 6px 4px #000000; */
}
.highlightCurrentLayer {
  background-color: rgba(216, 216, 216, 0.5);
  /* border-color: rgba(241, 241, 241, 0.6); */
  border-color: #007BFF;
  border-style: solid;
  height: 100%;
  /* box-shadow: inset 0px 0px 6px 4px #000000; */
}
.card-body-padding {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
.orange-font {
  color: orange !important;
}
.layer-border {
  border: 1px solid rgb(238, 238, 238);
}
.layer-border:hover {
  box-shadow: inset 0px 0px 6px 4px rgba(255, 255, 255, 0.5);
}
.vert-align {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}
.available-not-enabled {
  background: rgb(2.6, 97.5, 151.45);
}
.available-enabled {
  background: rgb(21.45, 140.4, 87.1);
}
.unavailable {
  background: rgb(20, 42.5, 55);
}
.row-margin {
  margin-left: 0.5%;
  margin-right: 0.5%;
}
.spinner-custom-position {
  position: absolute;
  right: 10px;
  bottom: -8px;
}

.layer-container {
  display: flex;
  align-items: center;
  position: relative; /* Ensures proper positioning */
  z-index: 1; /* Keeps the row above other elements */
}

/* Default UI remains the same */
.layer-content {
  flex-grow: 1;
}

/* The wrapper for the POI panel */
.poi-panel-wrapper {
  position: absolute;
  left: calc(100% + 1px); /* Positions it immediately to the right of the row */
  top: 0.5px;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden; /* Prevents overflow clipping */
}

/* The actual sliding panel */
.poi-panel {
  background: rgba(65, 65, 65, 0.8);
  color: white;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 0; /* Starts hidden */
  font-size: 0px !important;
  white-space: nowrap;
  transition: width 0.3s ease-in-out, font-size 0.3s ease-in-out 0.3s;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  /* border: 4px solid rgba(65, 65, 65, 1); */
  border-color: rgba(65, 65, 65, 1);
  border-style: solid;
  /* border-right-width: 4px; */
  border-width: 0px 4px 0px 0px !important;
  border-left: none;
}

/* Expanded state when hovered */
.poi-panel.expanded {
  width: 100px; /* Expands to 100px */
  font-size: 10px !important;
  border-width: 3px;
  transition: width 0.3s ease-in-out, font-size 0.2s ease-in-out 0.15s;
}

.poi-panel .remove-btn {
  display: none;
  font-size: 0px !important;
  transition: width 0.3s ease-in-out, font-size 0.3s ease-in-out 0.3s;
}

.poi-panel.expanded .remove-btn {
  width: 80%;
  height: 80%;
  display: block;
  font-size: 10px !important;
  transition: width 0.3s ease-in-out, font-size 0.2s ease-in-out 0.15s;
}
</style>

<script>
import draggable from 'vuedraggable'
import { orderMapLayers } from '../../../utils/utils';
export default {
  name: 'MMP_Analytics_LayerList',
  components: {
    draggable
  },
  props: [
    'analyticsVisible',
    'wclVisible',
    'wclLayersButtonsCtrl',
    'customerProjectId',
    'cust_layersObj',
    'layerResponse',
    'map',
    'mmp_layersObj',
    'otonomoSubcountry',
    'selectAllControl',
    'spinnerManager',
    'zoomEnded',
    'zoomLevelCap',
    'layerDefinition',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen'
  ],
  data() {
    return {
      layerButtons: [],
      filterClasses: [],
      oneToolToggle: true,
      currentIndex: 0,
      hoveredLayer: null // Track which layer is hovered
    }
  },
  methods: {
    removePOI() {
      const poiLayer = this.wclLayersButtonsCtrl.find((layer) => layer.name == 'POI Uploads')
      poiLayer.poi = false
      this.$emit('checkBorder')
    },
    removePanel() {
      this.hoveredLayer = null;
    },
    checkAllToolToggles() {
      this.oneToolToggle =
        this.ansiLayersToggle ||
        this.customerLayersToggle ||
        this.drtLayersToggle ||
        this.ushrLayersToggle
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] === layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name === layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    custLayerToggle(layerNameToToggle) {
      if (this.cust_layersObj[layerNameToToggle] != null) {
        let layerobj = this.cust_layersObj[layerNameToToggle].layer
        if (this.checkLayer(layerobj)) {
          this.map.removeLayer(layerobj)
          this.$emit('showCustomerLayer', false)
        } else {
          this.map.addLayer(layerobj)
          this.$emit('showCustomerLayer', true)
        }
      }
    },
    getLayerColClass(index, element) {
      let retVal = 'col col-no-pad py-1  '
      if (element.name != 'OSM') {
        let mapObjs =
          this.cust_layersObj != undefined
            ? this.cust_layersObj
            : this.mmp_layersObj
        let disabled = this.checkLayerDisable(
          element.name,
          element.zoomControl,
          element.minZoom
        )
        let displaying = this.checkLayer(mapObjs[element.name].layer)

        if (!disabled && displaying) {
          // Layer isn't disabled and layer is turned on
          retVal += ' available-enabled'
        } else if (!disabled) {
          // Layer isn't disabled and layer is turned off
          retVal += ' available-not-enabled'
        } else {
          // Layer is disabled
          retVal += ' unavailable'
        }
      } else {
        this.map.getLayers().forEach(layer => {
          if (layer != undefined && layer.get('name') != undefined) {
            if (layer.get('name').includes('OSM')) {
              retVal += ' available-enabled'
              //   retVal = 'btn capitalize cursor vert-align py-2 btn-secondary btn-sm col col-no-pad py-1 available-enabled'
            } else {
              retVal += ' available-not-enabled'
              // retVal= 'btn capitalize cursor vert-align py-2 btn-secondary btn-sm col col-no-pad py-1   available-not-enabled'
            }
          }
        })
      }
      return retVal
    },
    initFilterClasses() {
      let tempFilterClasses = []
      for (let i in this.layerButtons) {
        let layerName = this.layerButtons[i].name
        let objToPush = {
          'img-fluid': true,
          cursor: true,
          hover: false,
          sortable: true,
          'py-1': true
        }
        for (let rule in this.rules) {
          if (this.rules[rule].layer == layerName) {
            objToPush['orange-font'] = true
            break
          }
        }
        tempFilterClasses.push(objToPush)
      }
      this.filterClasses = tempFilterClasses
    },
    checkLayerDisable(layerName, zoomControl, minZoom) {
      /* checkLayerDisable method returns true if zoomControl is
      enabled and the user is zoomed in far enough. */
      this.$emit('updateZoomEnded', this.map.getView().getZoom())
      let returnClass = false
      let isANSILayer = ['ANSI', 'random_segments'].includes(layerName)
      let allowedANSI = [5, 22].includes(parseInt(this.customerProjectId))
      let layerExists = this.mmp_layersObj[layerName] != null
      let showLayer =
        minZoom == null
          ? this.zoomEnded >= this.zoomLevelCap
          : this.zoomEnded >= minZoom

      if ('Otonomo'.includes(layerName)) {
        /* returnClass is true if an Otonomo subcountry has been selected,
        zoomControl is enabled on the layer, and the user is zoomed in far enough. */
        returnClass = !(this.otonomoSubcountry && zoomControl && showLayer)
      } else if (layerExists && (!isANSILayer || allowedANSI)) {
        const layerObj = this.mmp_layersObj[layerName].layer
        if (!this.checkLayer(layerObj)) {
          /* returnClass is true if zoomControl is enabled on the
          layer and the user is zoomed in far enough. */
          returnClass = zoomControl && !showLayer
        }
      }

      return returnClass
    },
    onEnd() {
      let mapObjs =
        this.cust_layersObj != undefined
          ? this.cust_layersObj
          : this.mmp_layersObj
      orderMapLayers(mapObjs, this.layerButtons, this.map)
      this.map.getLayers().forEach(layer => {
        if (layer && layer.get('name') == this.layerButtons[0].name) {
          {
            this.$emit('loadAttributes', {
              name: this.layerButtons[0].name,
              layer_group: this.layerButtons[0].layer_group,
              response: this.layerResponse
            })
          }
        }
      })
      this.$emit('layerButtonsChanged', this.layerButtons)
      this.initFilterClasses()
    },
    toggleLayer(element, event) {
      let disabled = this.checkLayerDisable(
        element.name,
        element.zoomControl,
        element.minZoom
      )
      let layerName = element.name
      if (!disabled) {
        this.$emit('toggleLayerVisibility', layerName)
        this.onEnd()
      }

      event.target.blur();
    },
    toTopOfList(elementName) {
      let tool = "WCL"

      return new Promise((resolve) => {
        this.$emit('toTopOfList', { payload: { layerName: elementName, tool }, resolve })
      }).then(() => {
        this.onEnd()
      })
    },
    highlightTopLayer(index) {
      return (
        'sortable menu-item item py-2' +
        (index == 0 ? (this.currentIndex == 0 ? ' highlightCurrentLayer' : ' highlightTopLayer') : this.highlightCurrentLayer(index))
      )
    },
    highlightCurrentLayer(index) {
      return this.currentIndex == index ? ' highlightCurrentLayer' : ''
    },
    keyDownHandler(event) {
      if (['input', 'b-form-textarea', 'b-form-input', 'textarea'].includes(event.target.tagName.toLowerCase())) {
        return;
      }
      if (event.key === 'ArrowDown' && this.currentIndex < this.layerButtons.length - 1) {
        this.currentIndex++
        this.scrollToLayer(this.currentIndex)
      } else if (event.key === 'ArrowUp' && this.currentIndex > 0) {
        this.currentIndex--
        this.scrollToLayer(this.currentIndex)
      } else if (event.key == 'Enter') {
        let layer = this.layerButtons[this.currentIndex]
        this.toggleLayer(layer, event)
      }
    },
    scrollToLayer(index) {
      this.$nextTick(() => {
        let layer = document.getElementById(this.layerButtons[index].name) // get the layer element by its ID declared above
        if (layer) {
          layer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      })
    },
    removeIteratorListener() {
      window.removeEventListener('keydown', this.keyDownHandler)
    },
    addIteratorListener() {
      window.addEventListener('keydown', this.keyDownHandler)
    }
  },
  mounted() {
    this.layerButtons = this.wclLayersButtonsCtrl
    this.addIteratorListener()
  },
  beforeDestroy() {
    this.removeIteratorListener()
  },
  watch: {
    otonomoSubcountry: function (newValue, oldValue) {
      this.onEnd()
    },
    wclLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
    },
    showLidarPanel: function(newValue) {
      if (this.baseMapsOpen) {
        this.removeIteratorListener()
      } else if (this.extentsOpen) {
        this.removeIteratorListener()
      } if (newValue) {
        this.removeIteratorListener()
      } else {
        this.addIteratorListener()
      }
    },
    baseMapsOpen: function(newValue) {
      if (newValue) {
        this.removeIteratorListener() 
      } else if (this.extentsOpen) {
        this.removeIteratorListener()
      } else if (this.showLidarPanel) {
        this.removeIteratorListener()
      } else {
        this.addIteratorListener()
      }
    },
    extentsOpen: function (newValue) {
      if (newValue) {
        this.removeIteratorListener()
      } else if (this.baseMapsOpen) {
        this.removeIteratorListener()
      } else if (this.showLidarPanel) {
        this.removeIteratorListener()
      } else {
        this.addIteratorListener()
      }
    }
  }
}
</script>
